import React from 'react';

import { NavbarItem } from '@vlabs/monokit/shared/ui/navbar-panel';
import type { NavbarItemProps } from '@vlabs/uikit/components/navbar/navbar-item/NavbarItem';
import { useSelector } from 'react-redux';
import type { NavLink } from 'react-router-dom';

import { viewerCan } from '@vlabs/pages/auth/selectors';

import './NavbarLinkWithPermissions.sass';

interface NavbarLinkWithPermissionsProps extends NavbarItemProps<typeof NavLink> {
  permissions?: {
    rules: string[];
    method?: 'oneof' | 'allof';
  };
}

function NavbarLinkWithPermissions({
  permissions = undefined,
  ...props
}: NavbarLinkWithPermissionsProps): React.JSX.Element | null {
  const can = useSelector(viewerCan);
  const { rules = [], method = 'oneof' } = permissions ?? {};

  const hasPermission = can(rules, { method });

  if (!hasPermission) return null;

  return (
    <NavbarItem {...props} />
  );
}

export { NavbarLinkWithPermissions };
